export enum EmployeesSortingParam {
  Sort = 'sort',
  EmployeesWithActionsSort = 'employeesWithActionsSort',
}
